<template>
  <div class="container-fluid bg-white position-relative pt-3 pb-3">
    <Loader :visible="isLoading" />
    <b-modal
      v-model="show"
      title="Thông báo"
      ok-title="Tiếp tục"
      header-class="header-modal"
      content-class="content-modal"
      title-class="title-modal"
      cancel-title="Trở về"
      @ok="handleConfirm"
      @cancel="handleCancel"
      hide-footer
      centered
    >
      <template #modal-header>
        <div class="d-block w-100 text-center">
          <h3 class="header-text">Thông báo</h3>
        </div>
      </template>
      <p class="alert-content">
        Website hiện đang trong quá trình phát triển nên không tránh khỏi những sai sót. Bạn có chắc chắn muốn truy cập?
      </p>
      <b-row>
        <b-col cols="6">
          <b-button class="btn-common btn-cancel" block @click="handleCancel">Trở về</b-button>
        </b-col>
        <b-col cols="6">
          <b-button class="btn-common btn-yes" block @click="handleConfirm">Tiếp tục</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <div class="d-flex justify-content-center">
      <b-carousel
        id="carousel-1"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="1024"
        img-height="360"
        class="my-carousel"
        style="max-width: 100%; min-height: 241px; max-height: 50vh"
      >
        <!-- Text slides with image -->
        <b-carousel-slide
          v-for="(imageUrl, index) in banners"
          :img-src="imageUrl"
          :key="'banner' + index"
        ></b-carousel-slide>
      </b-carousel>
    </div>
    <b-row class="mt-3 d-flex align-items-center justify-content-center flex-column">
      <b-col><h3 class="custom-text">Khảo sát sức khỏe tâm thần</h3></b-col>
      <b-col xl="6" md="6" class="mb-3">
        <router-link :to="{ name: 'exam-info' }">
          <b-button class="button-start text-center">
            <strong>BẮT ĐẦU</strong>
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <div class="mt-4"><h3 class="custom-text">Trạm thông tin</h3></div>
    <b-row class="d-flex align-items-center justify-content-center">
      <b-col cols="6" sm="6" xl="6" md="6" class="mb-3">
        <router-link :to="{ name: 'procedure' }">
          <base-button icon class="button-common">
            <span class="btn-inner--text">Thủ tục hành chính</span>
          </base-button>
        </router-link>
      </b-col>
      <b-col cols="6" sm="6" md="6" xl="6" class="mb-3">
        <router-link :to="{ name: 'map' }">
          <base-button icon class="button-common">
            <span class="btn-inner--text">Sơ đồ</span>
          </base-button>
        </router-link>
      </b-col>
      <b-col cols="6" sm="6" xl="6" md="6" class="mb-3">
        <router-link :to="{ name: 'posts', query: { type: COLLECTION_TYPE.HEALTH } }">
          <base-button icon class="button-common">
            <span class="btn-inner--text">Chăm sóc bệnh nhân</span>
          </base-button>
        </router-link>
      </b-col>
      <b-col cols="6" sm="6" xl="6" md="6" class="mb-3">
        <router-link :to="{ name: 'posts', query: { type: COLLECTION_TYPE.PSYCH } }">
          <base-button icon class="button-common">
            <span class="btn-inner--text">Phương pháp hỗ trợ tâm lý</span>
          </base-button>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { collection, orderBy, query, getDocs } from 'firebase/firestore'
import { db } from '@/plugins/firebaseConfig'
import { COLLECTION_TYPE } from '../../util/constant'

const BANNER_DEFAULT = ['/img/banner/banner1.png', '/img/banner/banner2.png', '/img/banner/banner3.png']
export default {
  name: 'HomePage',
  components: {},
  data() {
    return {
      COLLECTION_TYPE: { ...COLLECTION_TYPE },
      show:
        typeof JSON.parse(sessionStorage.getItem('isShowInDeveloping')) == 'boolean'
          ? JSON.parse(sessionStorage.getItem('isShowInDeveloping'))
          : true,
      banners: [...BANNER_DEFAULT]
    }
  },
  created() {
    this.fetchImages() // Fetch images on component creation
  },
  methods: {
    async fetchImages() {
      const imagesCollection = collection(db, 'banners')
      const q = query(imagesCollection, orderBy('order'))
      const snapshot = await getDocs(q)
      this.banners = snapshot.docs.map((doc) => doc.data().url) || [...BANNER_DEFAULT]
    },
    goToRoute() {
      this.$router.push({ name: 'exam' })
    },
    handleConfirm() {
      sessionStorage.setItem('isShowInDeveloping', false)
      this.show = false
    },
    handleCancel() {
      this.$router.push('/')
    }
  }
}
</script>
<style>
.starter-page {
  /* min-height: calc(100vh - 380px); */
}
.my-carousel {
  border: 2px solid #aed0f5; /* Màu viền (có thể thay đổi theo ý muốn) */
  border-radius: 15px; /* Làm cho viền có góc bo tròn */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Thêm bóng cho carousel */
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.my-carousel .carousel-control-prev,
.my-carousel .carousel-control-next {
  background-color: rgba(0, 0, 0, 0.5); /* Nền của các nút điều khiển */
  border-radius: 15px; /* Bo tròn hình ảnh bên trong carousel */
}
.my-carousel .carousel-inner {
  border-radius: 15px; /* Bo tròn hình ảnh bên trong carousel */
}

.my-carousel .carousel-inner img {
  border-radius: 15px; /* Bo tròn hình ảnh bên trong carousel */
  width: 100%;
  height: 100%;
  object-fit: cover; /* Đảm bảo ảnh phủ đầy khung mà không bị méo */
}
.my-carousel .carousel-control-prev-icon,
.my-carousel .carousel-control-next-icon {
  filter: invert(1); /* Đổi màu biểu tượng điều khiển */
}
.custom-text {
  /* Khảo sát sức khỏe tâm thần */

  width: 100%;
  min-height: 36px;

  font-family: 'FS Magistral';
  font-style: normal;
  font-weight: 500;
  font-size: 1.5em;
  line-height: 36px;
  /* identical to box height */
  text-align: center;

  color: #0635a1;
}
.button-start {
  /* Vector_16 */
  width: 100%;
  height: 76px;

  background: #f79c33;

  font-family: 'FS Magistral';
  font-style: normal;
  font-weight: 700;
  font-size: 27.5px;
  line-height: 38px;
  /* identical to box height */
  text-align: center;

  color: #ffffff;
}
.button-common {
  /* Thủ tục hành chính */
  min-height: 75px;
  width: 100%;
  color: #fff;
  background-color: #1276a8;
  font-family: 'FS Magistral';
  font-size: 1em;
  line-height: 23px;
  text-align: center;
}
</style>
